import { type FC, useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';

import { useSimulatorStore } from 'store/useSimulatorStore.ts';

const RouteGuard: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { form } = useSimulatorStore();

  useEffect(() => {
    const currentPath = location.pathname;

    if (!form) {
      if (currentPath !== '/') {
        navigate('/', { replace: true });
        return;
      }
    }

    if (form) {
      if (currentPath === '/datos-cliente/otp/telefono' && !form.telefono) {
        navigate('/datos-cliente/telefono', { replace: true });
        return;
      }

      if (currentPath === '/datos-cliente/otp/correo' && !form.correo) {
        navigate('/datos-cliente/correo', { replace: true });
        return;
      }

      if (
        currentPath === '/datos-cliente/correo' &&
        (!form.valor_inmueble || !form.telefono)
      ) {
        navigate('/', { replace: true });
        return;
      }

      if (currentPath === '/datos-cliente/telefono' && !form.valor_inmueble) {
        navigate('/', { replace: true });
        return;
      }

      if (currentPath === '/cotizacion-prestamo') {
        if (!form.valor_inmueble) {
          navigate('/', { replace: true });
          return;
        }
        if (!form.telefono) {
          navigate('/datos-cliente/telefono', { replace: true });
          return;
        }
        if (!form.correo) {
          navigate('/datos-cliente/correo', { replace: true });
          return;
        }
      }
    }
  }, [location.pathname, form, navigate]);

  return <Outlet />;
};

export default RouteGuard;
